import { render, staticRenderFns } from "./EduAdminConnection.vue?vue&type=template&id=1e77578b"
import script from "./EduAdminConnection.vue?vue&type=script&lang=js"
export * from "./EduAdminConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports